import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { Source } from '@sodamnfoolish/sjc-backend-types/src/api/feed/dto';
import { Api } from '@sodamnfoolish/sjc-backend-types';
import { useFeedGeteway } from '../UseFeedGateway';
import { useLatestCallbackRef } from '../useLatestCallbackRef';

interface UseSourceMaintainer {
    onRegisterSource: (source: Source) => void;
    onUnregisterSource: (source: Source) => void;
}

export function useSourceMaintainer({ onRegisterSource, onUnregisterSource }: UseSourceMaintainer) {
    const { feedGatewayClient } = useFeedGeteway();

    const onRegisterSourceRef = useLatestCallbackRef(onRegisterSource);
    const onUnregisterSourceRef = useLatestCallbackRef(onUnregisterSource);

    useEffect(() => {
        if (!feedGatewayClient) return;

        feedGatewayClient.on(Api.Feed.Gateway.Event.UnregisterSource, (source: Api.Feed.DTO.Source) => {
            try {
                console.log('Source maintenance stopped', source);
                onUnregisterSourceRef.current(source);
                toast.error(`Source maintenance stopped ${source.username}`);
            } catch (err) {
                console.error(err);
                toast.error(`Failed to handle Source Maintanance Stopped event`);
            }
        });

        feedGatewayClient.on(Api.Feed.Gateway.Event.RegisterSource, (source: Api.Feed.DTO.Source) => {
            try {
                onRegisterSourceRef.current(source);
                console.log('Source maintenance started', source);
                toast.success(`Source maintenance started ${source.username}`);
            } catch (err) {
                console.error(err);
                toast.error(`Failed to handle Source Maintanance Started event`);
            }
        });

        return () => {
            feedGatewayClient.off(Api.Feed.Gateway.Event.UnregisterSource);
            feedGatewayClient.off(Api.Feed.Gateway.Event.RegisterSource);
        };
    }, [feedGatewayClient, onUnregisterSourceRef, onRegisterSourceRef]);
}
